import React from 'react';
import { createRoot } from 'react-dom/client';
import 'overlayscrollbars/styles/overlayscrollbars.css';
import './globals.css';
import './styleguide.css';
import App from './App';
import AppBootRecovery from './components/AppBootRecovery';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import {TourProvider} from './TourContext';
import { shouldRetryQuery } from './utils/queryRetry';
const client = new QueryClient({
  defaultOptions: {
    queries: {
      // 'always' is deliberate (3a21c74e0): navigator.onLine misreports offline in some
      // environments and left queries paused forever. It also means nothing pauses a
      // failing query, so the retry policy below is what bounds an offline retry storm:
      // never retry a 4xx that cannot succeed or a deterministic client failure, and at
      // most two retries (~3 s window) for network/5xx/transient failures. See utils/queryRetry.js.
      networkMode: 'always',
      retry: shouldRetryQuery,
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      networkMode: 'always',
    },
  },
});

const container = document.getElementById('app');
const root = createRoot(container);
root.render(
  <QueryClientProvider client={client}>
    <TourProvider>
    <App />
    <AppBootRecovery />
    </TourProvider>
    {/* <ReactQueryDevtools initialIsOpen={false} /> */}
  </QueryClientProvider>
);
